export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEMVW5pS1MtVUNTMi1IYRIgEwG+ewEAvn0OAL56n1sBvngFCb8BAQC/CwABvn+DnWsAvwwGAb8NAgC/DwEAvxALBb8RGwC/FwEAvxgBAL8ZGwK/GgAAvn6BBAC/HQ==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/UniKS-UCS2-V.bcmap
// module id = 726
// module chunks = 502